export const TRASH_RETENTION_DAYS = 30;
export const DEFAULT_TRASH_WINDOW = { days: TRASH_RETENTION_DAYS, legalHold: false };
//# sourceMappingURL=trash-defaults.js.map